import { Link } from 'react-router-dom';
import AnimatedSeparator from '../components/AnimatedSeparator';

const openCalendly = (e) => {
    e.preventDefault();
    if (window.Calendly) {
        window.Calendly.initPopupWidget({
            url: 'https://calendly.com/i-elashapira/idea-reality-check?primary_color=f52e72',
        });
    }
};

export default function ContactPage() {
    return (
        <div className="page-container">
            <div className="container">

                <div className="row page-hero align-items-end">
                    <div className="col-md-7">
                        <h1>Contact</h1>
                        <h2>questions? comments? ideas? let's talk!</h2>
                    </div>
                </div>

                <AnimatedSeparator color="#f52e72" />

                <div className="row">
                    <div className="col-md-3">
                        <h3>Book a<br />consultation</h3>
                    </div>
                    <div className="col-md-8 offset-md-1">
                        <p>
                            A paid 30-minute call with Ela Shapira — whether you're not ready to submit
                            a full Nursery application, need a second opinion, or want to think something
                            through out loud with someone who's seen it before.
                        </p>
                        <p style={{ marginBottom: '2rem' }}>
                            <span className="pink">€150</span> · 30 minutes · via Calendly
                        </p>
                        <a href="/" onClick={openCalendly} className="btn-primary">
                            Book via Calendly
                        </a>
                    </div>
                </div>

                <AnimatedSeparator color="#000" />

                <div className="row">
                    <div className="col-md-3">
                        <h3>Connect</h3>
                    </div>
                    <div className="col-md-8 offset-md-1">
                        <p>
                            For investress enquiries, partnership conversations, press, or anything that
                            doesn't fit a booking form:
                        </p>
                        <ul className="custom-bullets" style={{ marginBottom: '2rem' }}>
                            <li>
                                <span>LinkedIn</span>
                                <p>
                                    <a
                                        href="https://www.linkedin.com/in/elashapira"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        linkedin.com/in/elashapira
                                    </a>
                                </p>
                            </li>
                            <li>
                                <span>Email</span>
                                <p>
                                    <Link sx={{ cursor: "pointer" }}
                                        onClick={() => window.location.href = `mailto:${'nursery'}@${'startup-doula.com'}`}>
                                        {'nursery'}&#64;{'startup-doula.com'}
                                    </Link>
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>
    );
}
